// @ts-nocheck
import { Component } from 'react';
import { ApplyPluginsType } from 'umi';
import dva from 'dva';
// @ts-ignore
import createLoading from 'D:/CloudPatrolUI/Mayun.UI/node_modules/dva-loading/dist/index.esm.js';
import { plugin, history } from '../core/umiExports';
import ModelArea0 from 'D:/CloudPatrolUI/Mayun.UI/src/models/area.js';
import ModelBi1 from 'D:/CloudPatrolUI/Mayun.UI/src/models/bi.js';
import ModelCommunication2 from 'D:/CloudPatrolUI/Mayun.UI/src/models/communication.js';
import ModelDashboard3 from 'D:/CloudPatrolUI/Mayun.UI/src/models/dashboard.js';
import ModelDevice4 from 'D:/CloudPatrolUI/Mayun.UI/src/models/device.js';
import ModelGlobal5 from 'D:/CloudPatrolUI/Mayun.UI/src/models/global.js';
import ModelInteraction6 from 'D:/CloudPatrolUI/Mayun.UI/src/models/interaction.js';
import ModelLogin7 from 'D:/CloudPatrolUI/Mayun.UI/src/models/login.js';
import ModelMap8 from 'D:/CloudPatrolUI/Mayun.UI/src/models/map.js';
import ModelMenu9 from 'D:/CloudPatrolUI/Mayun.UI/src/models/menu.js';
import ModelMonitor10 from 'D:/CloudPatrolUI/Mayun.UI/src/models/monitor.js';
import ModelPlandata11 from 'D:/CloudPatrolUI/Mayun.UI/src/models/plandata.js';
import ModelSettings12 from 'D:/CloudPatrolUI/Mayun.UI/src/models/settings.js';

let app:any = null;

export function _onCreate(options = {}) {
  const runtimeDva = plugin.applyPlugins({
    key: 'dva',
    type: ApplyPluginsType.modify,
    initialValue: {},
  });
  app = dva({
    history,
    
    ...(runtimeDva.config || {}),
    // @ts-ignore
    ...(typeof window !== 'undefined' && window.g_useSSR ? { initialState: window.g_initialProps } : {}),
    ...(options || {}),
  });
  
  app.use(createLoading());
  (runtimeDva.plugins || []).forEach((plugin:any) => {
    app.use(plugin);
  });
  app.model({ namespace: 'area', ...ModelArea0 });
app.model({ namespace: 'bi', ...ModelBi1 });
app.model({ namespace: 'communication', ...ModelCommunication2 });
app.model({ namespace: 'dashboard', ...ModelDashboard3 });
app.model({ namespace: 'device', ...ModelDevice4 });
app.model({ namespace: 'global', ...ModelGlobal5 });
app.model({ namespace: 'interaction', ...ModelInteraction6 });
app.model({ namespace: 'login', ...ModelLogin7 });
app.model({ namespace: 'map', ...ModelMap8 });
app.model({ namespace: 'menu', ...ModelMenu9 });
app.model({ namespace: 'monitor', ...ModelMonitor10 });
app.model({ namespace: 'plandata', ...ModelPlandata11 });
app.model({ namespace: 'settings', ...ModelSettings12 });
  return app;
}

export function getApp() {
  return app;
}

export class _DvaContainer extends Component {
  constructor(props: any) {
    super(props);
    // run only in client, avoid override server _onCreate()
    if (typeof window !== 'undefined') {
      _onCreate();
    }
  }

  componentWillUnmount() {
    let app = getApp();
    app._models.forEach((model:any) => {
      app.unmodel(model.namespace);
    });
    app._models = [];
    try {
      // 释放 app，for gc
      // immer 场景 app 是 read-only 的，这里 try catch 一下
      app = null;
    } catch(e) {
      console.error(e);
    }
  }

  render() {
    const app = getApp();
    app.router(() => this.props.children);
    return app.start()();
  }
}
